export default __webpack_public_path__ + "static/media/WealthyNaiveHorseshoecrab-max-1mb.158a387d.gif";